import { AGENTS_PAGE } from './pages'

export const selectIsOnAgentsOverviewPage = state =>
  state.ducksPage.page === AGENTS_PAGE
